import {BackEndService} from "../../../utils/BackEndService";
import {userService} from "../UserService";
import { ExternalAuthUser } from "./models/ExternalAuthModel";
import {UserSignupData} from "./models/UserSignupData";
import { firebaseAuthenticationService } from "./external/FirebaseAuthenticationService";

class AuthenticationService {
  public loginWithFirebase(externalAuthUser: ExternalAuthUser) {
    return BackEndService.sendPostRequest('login/firebase', externalAuthUser)
      .then((response) => {
        userService.setUserData(response.data);
      })
      .catch((response) => {
        return Promise.reject(response.data);
      })
  }

  public login({email, password}: any) {
    return BackEndService.sendPostRequest('login', {email, password})
      .then((response) => {
        userService.setUserData(response.data);
        return true;
      })
      .catch(() => {
        return false;
      });
  }

  public sendChangePasswordEmail(email: string) {
    return BackEndService.sendPostRequest('password/forgot', {email});
  }
  public changeUserPassword({token, password}: any) {
    return BackEndService.sendPostRequest('password/change', {token: token, new_password: password})
      .then((res) => res.status);
  }

  /* Signup & Register */
  public subscribeToWaitlist(email: string) {
    return BackEndService.sendPostRequest('subscribe', {email, created_from: 'CREATED_FROM_FRONT'})
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response) {
          return Promise.reject(error.response);
        }
      });
  }

  public signup(userSignupData: UserSignupData) {
    return BackEndService.sendPostRequest('signup', userSignupData)
      .then((response) => {
        userService.setUserData(response.data)
        return Promise.resolve();
      }).catch((response) => {
        return Promise.reject(response.data);
      })
  }

  public signupWithFirebase(externalAuthUser: ExternalAuthUser) {
    return BackEndService.sendPostRequest('signup/firebase', externalAuthUser)
      .then((response) => {
        userService.setUserData(response.data)
      })
      .catch((response) => {
        return Promise.reject(response.data);
      })
  }

  public confirmUserCreation(data: any) {
    return BackEndService.sendPostRequest('auth/confirm', data)
      .then((response) => {
        return Promise.resolve(response.data);
      }).catch((response) => {
        return Promise.reject(response.data);
      })
  }

  public async logout() {
    delete localStorage.tokenTokatab;

    if(userService.user.isConnectedWithExternalProvider) {
      await firebaseAuthenticationService.logout()
    }

    userService.logout();
    window.location.replace('#/login');
  }
}

export const authenticationService = new AuthenticationService();
